import styled from 'styled-components';

import { Row } from 'components/Layout/Grid';
import { colors } from 'pages/Quotes/styles/colors';

import { ShippingCompanyStyledProps } from './interface';

export const Container = styled.div<ShippingCompanyStyledProps>`
  max-width: ${(props: any) => props.userTypeIsCustomer ? "1100px" : "none"};
  margin:  ${(props: any) => props.userTypeIsCustomer ? "0 auto" : "0 37px 0 10px"};
  padding: ${(props: any) => props.userTypeIsCustomer ?
    "0.625rem 0 0 0" : "2.188rem 0 0 0"};
`;

export const Content = styled.div<ShippingCompanyStyledProps>`
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    box-shadow: 0px 3px 3px rgb(0 0 0 / 10%);
    border-radius: 10px;
    align-items: center;

    gap: 1.25rem;
    display: grid;

    grid-template-columns: ${(props: any) => props.userTypeIsCustomer ?
    "180px 435px 1fr" : "185px minmax(315px,auto) 1fr"};

    padding: 1.25rem 1.25rem;

    @media only screen and (max-width: 1115px) {
      grid-template-columns: none;

      .imgShippingCompany {
        grid-area: imgShippingCompany;
      }
      ​
      .textShippingCompany {
        grid-area: textShippingCompany;
      }
      ​
      .buttonShippingCompany {
        grid-area: buttonShippingCompany;
      }

      grid-template-areas:
      "imgShippingCompany textShippingCompany"
      "imgShippingCompany buttonShippingCompany"
      ;
    }

    @media only screen and (max-width: 920px) {
      .imgShippingCompany, .textShippingCompany, .buttonShippingCompany {
        grid-area: unset;
      }
      grid-template-areas: none;
      grid-template-columns: repeat(auto-fit, minmax(430px, auto));
    }

    @media only screen and (max-width: 520px) {
      display: flex;
      flex-direction: column;
      grid-template-areas: none;
    }

    button {
      border-radius: 0.625rem;
      width: 120px;
      height: 120px;

      border: 1px solid ${colors.whitesmoke};
    }
`;

export const RowMenuItem = styled(Row)`
  @media only screen and (max-width: 1284px) {
    justify-content: end;
  }

  @media only screen and (max-width: 920px) {
    justify-content: start;
  }

  @media only screen and (max-width: 520px) {
    justify-content: center;
    flex-wrap: wrap;
    max-width: 400px;
  }
`;

const DefaultText = styled.p`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 0.813rem;
  line-height: 1rem;
  letter-spacing: -0.015rem;
`;

export const TextShippingCompany = styled(DefaultText)`
  color: ${colors.blueDark};
`;